import { createSelector } from 'reselect'

import { initialState, initialBrandState, initialProgressStatusState } from '../reducers/reindexReducer'

const stateSelector = (state) => state.reindex || initialState

const idPropSelector = (_, props) => props.id

export const allBrandIdsSelector = createSelector(stateSelector, (state) => {
  const sorted = [...state.brandsAllIds]
  sorted.sort((a, b) => state.brandsById[a].fullName.localeCompare(state.brandsById[b].fullName))
  return sorted
})
export const brandByIdSelector = createSelector([stateSelector, idPropSelector], (state, id) => state.brandsById[id] || initialBrandState)
export const brandsFetchingSelector = createSelector(stateSelector, (state) => state.brandsFetching)
export const brandsFetchedSelector = createSelector(stateSelector, (state) => state.brandsFetched)
export const brandsErrorSelector = createSelector(stateSelector, (state) => state.brandsError)

export const brandFullNameSelector = createSelector(brandByIdSelector, (brand) => brand.fullName)
export const brandIndexNameSelector = createSelector(brandByIdSelector, (brand) => brand.indexName)
export const brandProvidersSelector = createSelector(brandByIdSelector, (brand) => brand.providers)
export const brandIndexCountSelector = createSelector(brandByIdSelector, (brand) => brand.indexedCount)
export const brandTotalSelector = createSelector(brandByIdSelector, (brand) => brand.totalCount)
export const brandPercentageSelector = createSelector(brandByIdSelector, (brand) => brand.percentage)
export const brandProgressStatusSelector = createSelector(brandByIdSelector, (brand) => brand.progressStatus || initialProgressStatusState)

export const brandStatusMessageSelector = createSelector(brandProgressStatusSelector, (brandStatus) => brandStatus.message)
export const brandStatusRunningSelector = createSelector(brandProgressStatusSelector, (brandStatus) => brandStatus.running)
export const brandStatusErrorSelector = createSelector(brandProgressStatusSelector, (brandStatus) => brandStatus.error)
export const brandStatusProgressSelector = createSelector(brandProgressStatusSelector, (brandStatus) => brandStatus.progress)
export const brandStatusTotalSelector = createSelector(brandProgressStatusSelector, (brandStatus) => brandStatus.total)
export const brandStatusFinishedSelector = createSelector(brandProgressStatusSelector, (brandStatus) => brandStatus.finished)
export const brandStatusCancelledSelector = createSelector(brandProgressStatusSelector, (brandStatus) => brandStatus.cancelled)

export const brandProgressFetchingSelector = createSelector(brandByIdSelector, (brand) => brand.progressFetching)
export const brandProgressFetchedSelector = createSelector(brandByIdSelector, (brand) => brand.progressFetched)
export const brandProgressErrorSelector = createSelector(brandByIdSelector, (brand) => brand.progressError)

export const brandFetchStatusFetchingSelector = createSelector(brandByIdSelector, (brand) => brand.statusFetching)
export const brandFetchStatusFetchedSelector = createSelector(brandByIdSelector, (brand) => brand.statusFetched)
export const brandFetchStatusErrorSelector = createSelector(brandByIdSelector, (brand) => brand.statusError)

export const contentTypesSelector = createSelector(stateSelector, (state) => state.contentTypes)
export const selectedContentTypesSelector = createSelector(stateSelector, (state) => state.selectedContentTypes)
export const contentTypesFetchingSelector = createSelector(stateSelector, (state) => state.contentTypesFetching)
export const contentTypesFetchedSelector = createSelector(stateSelector, (state) => state.contentTypesFetched)
export const contentTypesErrorSelector = createSelector(stateSelector, (state) => state.contentTypesError)

export const versionsSelector = createSelector(stateSelector, (state) => state.versions)
export const versionsFetchingSelector = createSelector(stateSelector, (state) => state.versionsFetching)
export const versionsFetchedSelector = createSelector(stateSelector, (state) => state.versionsFetched)
export const versionsErrorSelector = createSelector(stateSelector, (state) => state.versionsError)

export const reindexBrandPendingSelector = createSelector(stateSelector, (state) => state.reindexBrandPending)
export const reindexBrandSuccessSelector = createSelector(stateSelector, (state) => state.reindexBrandSuccess)
export const reindexBrandErrorSelector = createSelector(stateSelector, (state) => state.reindexBrandError)

export const stopReindexPendingSelector = createSelector(stateSelector, (state) => state.stopReindexPending)
export const stopReindexSuccessSelector = createSelector(stateSelector, (state) => state.stopReindexSuccess)
export const stopReindexErrorSelector = createSelector(stateSelector, (state) => state.stopReindexError)

export const reindexByIdPendingSelector = createSelector(stateSelector, (state) => state.reindexByIdPending)
export const reindexByIdSuccessSelector = createSelector(stateSelector, (state) => state.reindexByIdSuccess)
export const reindexByIdErrorSelector = createSelector(stateSelector, (state) => state.reindexByIdError)

export const setVersionsPendingSelector = createSelector(stateSelector, (state) => state.setVersionsPending)
export const setVersionsSuccessSelector = createSelector(stateSelector, (state) => state.setVersionsSuccess)
export const setVersionsErrorSelector = createSelector(stateSelector, (state) => state.setVersionsError)
